import React from 'react';
import { AppSettings, Profile } from '../../types';
import styles from './SettingsManager.module.scss';
import { ClockStyleSelector } from './components/ClockStyleSelector';
import { TestPreviewSelector } from './components/TestPreviewSelector';

interface ThemeColors {
  textColor: string;
  accentColor: string;
  secondaryText: string;
}

interface SettingsManagerProps {
  settings: AppSettings;
  profiles: Profile[];
  onSettingsChange: (settings: AppSettings) => void;
  themeColors?: ThemeColors;
}

export function SettingsManager({ settings, onSettingsChange, themeColors }: SettingsManagerProps) {
  const titleStyle: React.CSSProperties = themeColors ? {
    color: themeColors.textColor
  } : {};

  return (
    <div className={styles.container}>
      <h3 className={styles.sectionTitle} style={titleStyle}>
        ⚙️ Display Settings
      </h3>

      <ClockStyleSelector
        settings={settings}
        onSettingsChange={onSettingsChange}
        themeColors={themeColors}
      />

      <TestPreviewSelector
        settings={settings}
        onSettingsChange={onSettingsChange}
        themeColors={themeColors}
      />
    </div>
  );
}
